import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Style from "../../../../../styles/js/StyleCallList.js";
import EditIcon from '@mui/icons-material/Edit';
import ConfirmIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import service from "../../../../../plas/services/calls/service.jsx";
import alerter from "../../../../alerts/alerter";

export default function FormDetails( { form } ) {

  const style = Style();
  const [editing, setEditing] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [actualForm, setActualForm] = React.useState(form);
  const [originalForm, setOriginalForm] = React.useState(form);

  const startEditing = () => {
    setEditing(true);
  }

  const stopEditing = () => {
    setActualForm(originalForm);
    setEditing(false);
  }

  const saveChanges = () => {
    setUpdating(true);
    var newDetails = { id: form.id, name: actualForm.name, description: actualForm.description }
    service.api.configurations.update(newDetails, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setEditing(false);
        form.name = actualForm.name;
        form.description = actualForm.description;
        setOriginalForm(actualForm);
      }
      
      setUpdating(false);
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setActualForm({ ...actualForm, [name]: value });
  };

  return (
    <div >
      <Card style={{ marginBottom: "15px"}}>
        <div className={style.itemHeader}>
          <Typography className={style.titleInitial}>
            Formulario #{actualForm.id}
          </Typography>
          <div style={{ marginLeft: 'auto' }} >
            { updating ? 
              (
                <IconButton disabled={true} aria-label="delete" style={{ color: 'white' }}>
                 <CircularProgress color="inherit" size={22}/>
                </IconButton>
              ) : (
                <div>
                { editing ? 
                  (
                    <div>
                      <Tooltip title="Cancelar">    
                        <IconButton aria-label="cancel" style={{ color: 'white' }} onClick={ () => { stopEditing() }}>
                          <CancelIcon font-size="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Confirmar">    
                        <IconButton aria-label="confirm" style={{ color: 'white' }} onClick={ () => { saveChanges() }}>
                          <ConfirmIcon font-size="small"/>
                        </IconButton>
                      </Tooltip>
                    </div>
                  ) : 
                  ( 
                    <Tooltip title="Editar">    
                      <IconButton aria-label="edit" style={{ color: 'white' }} onClick={ () => { startEditing() }} >
                        <EditIcon font-size="small"/>
                      </IconButton>
                    </Tooltip>
                  )
                }
                </div>
              )
            }
          </div>
          
        </div>
        <div style={{ textAlign:"left", padding: '12px'}}>
          <div className={style.itemContent}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined" 
                  id="name"
                  label="Nombre"
                  name="name"
                  fullWidth
                  value={actualForm.name}
                  onChange={handleChange}
                  placeholder="Nombre del formulario"
                  disabled={!editing}/>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined" 
                  id="description"
                  label="Descripción"
                  name="description"
                  multiline
                  fullWidth
                  value={actualForm.description}
                  placeholder="Breve descripción del formulario"
                  onChange={handleChange}
                  disabled={!editing}/>
              </Grid>
            </Grid>
          </div>
        </div>
      </Card>

    </div>

  );
}
